//Loop2 body content
import { Dot } from 'lucide-react'
import LoopthreeImg from '../../Assets/images/loop3Img.svg'
import './loopview.css'
import { IMG_PATH } from '../../server'
import { Circle } from 'lucide-react'

const LoopEightbody = ({ data }) => {
  return (
    <div className='pl-0 pr-5'>
      <h5 className='title'>
        {data.TitleName.split('\n').map((line, index) => (
          <div key={index} className='title-line'>
            {line}
          </div>
        ))}
      </h5>

      <p className='bodytext1'>Today you explored:</p>
      <p className='bodytext2 flex items-start gap-2 mb-2'>
        {/* <Dot size = {20} className='mt-1' /> */}
        <Circle
          size={7}
          fill='black'
          strokeWidth={0}
          className='mt-1 flex-shrink-0 self-start'
        />
        <span className='block w-full text-justify'>
          {data.LearningSummaryPoint1}
        </span>
      </p>

      <p className='bodytext2 flex items-start gap-2 mb-2'>
        {/* <Dot className='mt-1' /> */}
        <Circle
          size={7}
          fill='black'
          strokeWidth={0}
          className='mt-1 flex-shrink-0 self-start'
        />
        <span className='block w-full text-justify'>
          {data.LearningSummaryPoint2}
        </span>
      </p>

      <p className='bodytext2 flex items-start gap-2 mb-2'>
        {/* <Dot className='mt-1' /> */}
        <Circle
          size={7}
          fill='black'
          strokeWidth={0}
          className='mt-1 flex-shrink-0 self-start'
        />
        <span className='block w-full text-justify'>
          {data.LearningSummaryPoint3}
        </span>
      </p>

      <p className='mb-3'></p>

      {/* {data.image2 ? (
        <img src={IMG_PATH + data.image2} alt='LooptwoImg' className='m-0' />
      ) : (
        <img src={LoopthreeImg} alt='LooptwoImg' className='m-0' />
      )} */}
      <div className='w-full aspect-[1080/672] mt-3 rounded-md shadowview overflow-hidden'>
        {data.image2 ? (
          <img
            src={IMG_PATH + data.image2}
            alt='LooptwoImg'
            className='w-full h-full object-cover m-0'
          />
        ) : (
          <img
            src={LoopthreeImg}
            alt='LooptwoImg'
            className='w-full h-full object-cover m-0'
          />
        )}
      </div>
    </div>
  )
}

export default LoopEightbody
